// extracted by mini-css-extract-plugin
export default {"headshot":"styles_headshot__hYLOt"};